import { err, ok, Result } from 'neverthrow';

/**
 * Allows a function to be called safely and returns a Result instead of throwing an error.
 *
 * @param fn Async function which throws an error when called.
 * @returns A Result containing either the resolved value or the error that was thrown.
 */
export const safeAsync = async <T>(
  fn: () => Promise<T>,
): Promise<Result<T, Error>> => {
  try {
    return ok(await fn());
  } catch (error) {
    return err(error instanceof Error ? error : new Error(String(error)));
  }
};
